import * as React from "react"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"

const H4 = styled.div<{ textAlign?: string; color?: string }>`
  font-size: 20px;
  font-family: "Inter", sans-serif;
  color: ${(props) => props.color ?? props.theme.colors.greyDark};
  text-align: ${(props) => props.textAlign ?? "left"};
  line-height: 23.38px;
  font-weight: 600;

  ${MediaQuery.XS} {
    font-size: 16px;
    line-height: 19px;
  }
`

export default H4
